/* eslint-disable import/no-mutable-exports */
import { type ReactFlowInstance, useReactFlow } from '@xyflow/react';

let reactFlowInstance: ReactFlowInstance | null = null;

// ref: https://ant.design/components/app#global-scene-redux-scene
/**
 * A hook to get the ReactFlowInstance.
 * Ensables Usage of `reactFlowInstance` outside of React components.
 * Mount the component in the root of the application before using the static functions.
 */
export default function ReactFlowUtil() {
  const staticReactFlowInstance = useReactFlow();

  reactFlowInstance = staticReactFlowInstance;

  return null;
}

export { reactFlowInstance };
